import { ReactSession } from 'react-client-session';

ReactSession.setStoreType("localStorage");

const set = (key, value) => ReactSession.set(key, value)

const get = key => ReactSession.get(key)

export { set, get }